<template>
    <div 
        style="width: 100%; 
            height: 100%; 
            position: relative;
            overflow: hidden;
            box-sizing: border-box;" 
        :style="{
            paddingBottom: `${is_show && rail_h_show && inner_occupy ? inner_config.size : 0}px`,
            paddingRight: `${is_show && rail_v_show && inner_occupy ? inner_config.size : 0}px`
        }"
        v-resize="panelResize"
    >
        <div class="scrollbar" 
            @mouseenter="handleMouseEnter" 
            @mouseleave="handleMouseLeave"
        >
            <div class="panel" ref="panel" 
                :class="{'disable-x': inner_disableX,'disable-y': inner_disableY}" 
                :style="{
                    height: inner_disableX ? '100%' : `calc(100% + ${scrollbarWidth}px)`,
                    marginRight: inner_disableY ? 0 : -scrollbarWidth + 'px',
                    marginBottom: inner_disableX ? 0 : -scrollbarWidth + 'px'
                }"
                @scroll="scroll"
            >
                <div class="view" ref="view" v-resize="viewResize">
                    <slot />
                </div>
            </div>
        </div>
        <div class="rail_vertical" ref="rail_v" 
            :class="{active: !inner_disableY && is_show && rail_v_show}"
            :style="{
                width: inner_config.size + 'px',
                height: `calc(100% - ${inner_config.size*0.6}px)`,
                top: `${inner_config.size*0.3}px`,
                background: inner_config.rail.color,
                transform: `translateX(${ !inner_disableY && is_show && rail_v_show ? 0 : inner_config.size }px)`,
                borderRadius: inner_config.rail.radius + 'px'
            }"
            @mousedown="rail_v_mousedown"
        >
            <div class="bar_y" ref="bar_y"
                :style="{
                    background: inner_config.bar.color,
                    borderRadius: inner_config.bar.radius + 'px'
                }"
                @mousedown.stop
            ></div>
        </div>
        <div class="rail_horizontal" ref="rail_h" 
            :class="{active: !inner_disableX && is_show && rail_h_show}"
            :style="{
                height: `${inner_config.size}px`,
                width: `calc(100% - ${inner_config.size*0.6}px)`,
                left: `${inner_config.size*0.3}px`,
                background: inner_config.rail.color,
                transform: `translateY(${ !inner_disableX && is_show && rail_h_show ? 0 : inner_config.size }px)`,
                borderRadius: inner_config.rail.radius + 'px'
            }"
            @mousedown="rail_h_mousedown"
        >
            <div class="bar_x" ref="bar_x"
                :style="{
                    background: inner_config.bar.color,
                    borderRadius: inner_config.bar.radius + 'px'
                }"
                @mousedown.stop
            ></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'scrollbar',
        props: {
            config: Object,
            // 是否自动隐藏滚动条
            autohide: Boolean,
            // 占据位置
            occupy: Boolean,
            disableX: Boolean,
            disableY: Boolean
        },
        data: _=>({
            scrollbarWidth: 0,
            bar_y_height: 0,
            bar_x_width: 0,
            rail_v_height: 0,
            rail_h_width: 0,
            // 内容容器宽度
            view_width: 0,
            // 内容容器高度
            view_height: 0,
            // 正在拖拽y轴滚动条zx
            drag_y: false,
            // 正在拖拽x轴滚动条
            drag_x: false,
            // y轴偏移滚动条距离
            num_y: 0,
            // x轴偏移滚动条距离
            num_x: 0,
            // 鼠标移动在滚动区域
            is_hover: false,
            // 滚动条是否显示
            is_show: false,
            // 样式配置
            inner_config: {
                size: 10,
                rail: {
                    color: 'transparent',
                    radius: 0
                },
                bar: {
                    color: 'rgb(82, 82, 82)',
                    radius: 6
                }
            },
            // 原生 纵向滚动条长度
            scrollHeight: 0,
            // panel 容器高度
            clientHeight: 0,
             // 原生 横向滚动条长度
            scrollWidth: 0,
            // panel 容器宽度
            clientWidth: 0
        }),
        computed: {
            rail_v_show() {
                return this.bar_y_height < this.rail_v_height
            },
            rail_h_show() {
                return this.bar_x_width < this.rail_h_width
            },
            ratio_y() {
                return (this.scrollHeight - this.clientHeight) / (this.rail_v_height - this.bar_y_height)
            },
            ratio_x() {
                return (this.scrollWidth - this.clientWidth) / (this.rail_h_width - this.bar_x_width)
            },
            inner_autohide() {
                let autohide;

                try {
                   autohide = this.config.autohide || this._global_config.autohide
                } catch (error) {} 

                return this.autohide || autohide
            },
            inner_occupy() {
                let occupy;
                
                try {
                    occupy = this.config.occupy || this._global_config.occupy 
                } catch (error) {}

                return this.occupy || occupy
            },
            inner_disableX() {
                let disableX;
                
                try {
                    disableX = this.config.disableX || this._global_config.disableX 
                } catch (error) {}

                return this.disableX || disableX
            },
            inner_disableY() {
                let disableY;
                
                try {
                    disableY = this.config.disableY || this._global_config.disableY 
                } catch (error) {}

                return this.disableY || disableY
            },
            inner_gutterOfStart() {
                let gutterOfStart = this.inner_config.size*0.3;
                
                try {
                    let config = this.config,
                        _global_config = this._global_config;
                    _global_config.rail && _global_config.rail.gutterOfStart && (_global_config = _global_config.rail.gutterOfStart)
                    config.rail && config.rail.gutterOfStart && (config = config.rail.gutterOfStart)
                } catch (error) {}

                return gutterOfStart
            },
            inner_gutterOfEnd() {
                let inner_gutterOfEnd = this.inner_config.size*0.3;
                
                try {
                    let config = this.config,
                        _global_config = this._global_config;
                    _global_config.rail && _global_config.rail.inner_gutterOfEnd && (_global_config = _global_config.rail.inner_gutterOfEnd)
                    config.rail && config.rail.inner_gutterOfEnd && (config = config.rail.inner_gutterOfEnd)
                } catch (error) {}

                return inner_gutterOfEnd
            }
        },
        created() {

            this.is_show = !this.inner_autohide

            let global_config = require('../index').default?.get_config();

            this._global_config = global_config

            // 组件传入配置优先于全局配置
            let config = Object.assign({},global_config,this.config),
                inner_config = this.inner_config;

            this.inner_config = {
                size: config.size || inner_config.size,
                rail: {
                    ...inner_config.rail,
                    ...config.rail
                },
                bar: {
                    ...inner_config.bar,
                    ...config.bar
                }
            }
        },
        mounted() {
                
            this.getScrollbarWidth();

            this.init();

            this.bind();
        },
        methods: {
            rail_v_mousedown(e) {
                var line = this.rail_v_height - this.bar_y_height / 2;
                let top = e.offsetY - this.bar_y_height / 2
                top = top > line ? line : top

                this.scrollTo({top})
            },
            rail_h_mousedown(e) {
                var line = this.rail_h_width - this.bar_x_width / 2;
                let left = e.offsetX - this.bar_x_width / 2;
                left = left > line ? line : left

                this.scrollTo({left})
            },
            getScrollbarWidth() {
                var oP = document.createElement('p'),
                    styles = {
                        width: '100px',
                        height: '100px',
                        overflowY: 'scroll'
                    }, i, scrollbarWidth;
                for (i in styles) oP.style[i] = styles[i];
                document.body.appendChild(oP);
                // 滚动条宽度精度处理
                scrollbarWidth = Math.ceil(oP.offsetWidth - oP.clientWidth);
                oP.remove();

                this.scrollbarWidth = scrollbarWidth

                return scrollbarWidth;
            },
            scrollTo(options) {
                this.move(options,'scrollTo')
            },
            scrollBy(options) {
                this.move(options,'scrollBy')
            },
            // 鼠标移入
            handleMouseEnter() {
                this.is_hover = true
                this.is_show = true
            },
            // 鼠标移出
            handleMouseLeave() {
                this.is_hover = false
                this.is_show = !this.inner_autohide
            },
            // 父尺寸改变回调
            panelResize(data) {
                this.$nextTick(_=>{
                    this.getScrollbarWidth();

                    this.init();
                })
            },
            // 容器尺寸改变回调
            viewResize(data) {
                console.log('viewResize')
                this.$nextTick(_=>{
                    this.getScrollbarWidth();

                    this.init();
                })
                
                this.$emit('resize',data)
            },
            // 原生滚动事件
            scroll(e) {

                const $panel  = e.target;

                let dragingY = this.drag_y,
                    dragingX = this.drag_x;

                if (!dragingY && this.rail_v_show)
                    this.setBarYTop($panel.scrollTop / this.ratio_y);

                this.drag_y = false

                if (!dragingX && this.rail_h_show)
                    this.setBarXLeft($panel.scrollLeft / this.ratio_x)

                this.drag_x = false

                this.$emit('scroll',{
                    // dragingY
                    // dragingX
                    scrollTop: this.num_y,
                    scrollLeft: this.num_x,
                    barVSize: this.bar_y_height,
                    barHSize: this.bar_x_width,
                    scrollWidth: this.rail_h_width,
                    scrollHeight: this.rail_v_height,
                    viewWidth: this.view_width,
                    viewHeight: this.view_height,
                    processV: parseFloat(((this.bar_y_height + this.num_y) / this.rail_v_height).toFixed(1)),
                    processH: parseFloat(((this.bar_x_width + this.num_x) / this.rail_h_width).toFixed(1)),
                    nativeEvent: e
                })
            },
            move(options,name) {
                if (options.constructor != Object) throw(name + ' options is not Object')

                let smooth = options.smooth

                smooth === undefined && (smooth = true)

                if (smooth.constructor != Boolean) throw(name + ' options propertie smooth is not a Boolean')

                smooth = smooth ? 'smooth' : 'auto'

                const filter = (v = 0,rail_size) => {
                    let cons = v.constructor
                    if (cons == Number)
                        return v
                    else if (cons == String){
                        if (v.indexOf('%') != -1)
                            return parseFloat(v.split('%')[0]) / 100 * rail_size
                        else if (v.indexOf('px') != -1)
                            return parseFloat(v.split('px')[0])
                    }
                    
                    throw(name + ' method Properties of options is not String or Number')
                };
                
                const $refs = this.$refs,
                    $panel = $refs.panel;

                let top,left;

                if (options.left !== undefined) {
                    let x = filter(options.left,this.rail_h_width - this.bar_x_width);

                    left = x * this.ratio_x
                }else 
                    left = $panel.scrollLeft
                
                if (options.top !== undefined) {
                    let y = filter(options.top,this.rail_v_height - this.bar_y_height);

                    top = y * this.ratio_y
                }else 
                    top = $panel.scrollTop

                $panel[name]({
                    top,
                    left,
                    behavior: smooth
                });
            },
            // 设置纵向滚动条滑块位置
            setBarYTop(num) {
                const $refs = this.$refs,
                    $bar_y  = $refs.bar_y;

                // 滚动条运行区间
                var line = this.rail_v_height - this.bar_y_height;

                line < 0 && (line = 0)

                num = num >= line ? line : num

                num = num < 0 ? 0 : num

                // $bar_y.style.top = num + 'px';

                $bar_y.style.transform = `translateY(${num}px)`

                this.num_y = num;

            },
            // 设置横向滚动条滑块位置
            setBarXLeft(num) {
                const $refs = this.$refs,
                    $bar_x  = $refs.bar_x;

                // 滚动条运行区间
                var line = this.rail_h_width - this.bar_x_width;

                line < 0 && (line = 0)

                num = num >= line ? line : num

                num = num < 0 ? 0 : num

                // $bar_x.style.left = num + 'px';

                $bar_x.style.transform = `translateX(${num}px)`

                this.num_x = num
            },
            // 绑定事件
            bind() {
                // 纵轴
                (_=>{
                    const $refs = this.$refs,
                    $panel  = $refs.panel,
                    $rail_v = $refs.rail_v,
                    $bar_y  = $refs.bar_y;

                    $bar_y.onmousedown  = null;
                    $bar_y.onmousedown  = event => {
                        event.preventDefault();//清除默认行为

                        var startY = event.clientY;
                        
                        let move = e => {
                            e.preventDefault();//清除默认行为
                            
                            const top = this.num_y;

                            let value = e.clientY - startY;

                            this.setBarYTop(value + top);

                            this.drag_y = true

                            $panel.scrollTop = (value + top) * this.ratio_y

                            startY = e.clientY
                            
                        }

                        this.$emit('drag_start',true,false)

                        document.addEventListener('mousemove', move, false);

                        document.onmouseup = e => {

                            document.removeEventListener('mousemove',move,false);

                            e.preventDefault();//清除默认行为

                            document.onmouseup = null;

                            this.$emit('drag_end')
                        }
                    };
                })();

                // 横轴
                (_=>{
                    const $refs = this.$refs,
                        $panel  = $refs.panel,
                        $rail_h = $refs.rail_h,
                        $bar_x  = $refs.bar_x;

                    $bar_x.onmousedown  = null;
                    $bar_x.onmousedown  = event => {
                        event.preventDefault();//清除默认行为

                        var startX = event.clientX;

                        let move = e => {
                            e.preventDefault();//清除默认行为

                            const left = this.num_x;

                            let value = e.clientX - startX;

                            this.setBarXLeft(value + left);

                            this.drag_x = true

                            $panel.scrollLeft = (value + left) * this.ratio_x

                            startX = e.clientX
                        }

                        this.$emit('drag_start',false,true)

                        document.addEventListener('mousemove', move, false);

                        document.onmouseup = e => {

                            document.removeEventListener('mousemove',move,false);

                            e.preventDefault();//清除默认行为

                            document.onmouseup = null;

                            this.$emit('drag_end')
                        }
                    };
                })();
            },
            // 初始化尺寸
            init() {
                let set_bar_y_height = _=> {
                    const $refs = this.$refs,
                        $panel  = $refs.panel,
                        $rail_v = $refs.rail_v,
                        $bar_y  = $refs.bar_y;

                    // 滚动条高度
                    let scrollHeight = $panel.scrollHeight;

                    this.scrollHeight = scrollHeight;

                    let clientHeight = $panel.clientHeight;

                    this.clientHeight = clientHeight;

                        // 纵向滑轨高度
                    let rail_v_height = $rail_v.clientHeight

                        // 计算纵向滚动条滑块高度
                    let bar_y_height = clientHeight / scrollHeight * rail_v_height;

                    bar_y_height = bar_y_height < 20 ? 20 : bar_y_height;

                    this.rail_v_height = rail_v_height;

                    this.bar_y_height = bar_y_height;
                    
                    let call = _=>{ 
                        $bar_y.style.height = this.bar_y_height + 'px';

                        this.$nextTick(_=>{
                            // 重置滑块位置
                            this.setBarYTop($panel.scrollTop / this.ratio_y);
                        })
                    }

                    if (this.bar_y_height < rail_v_height) 
                        call()
                    else 
                        $rail_v.addEventListener('transitionend', call, { once: true })
                    
                };
                let set_bar_x_width = _=> {
                    const $refs = this.$refs,
                        $panel  = $refs.panel,
                        $rail_h = $refs.rail_h,
                        $bar_x  = $refs.bar_x;

                        // 滚动条宽度
                    let scrollWidth = $panel.scrollWidth,
                        clientWidth = $panel.clientWidth,
                        // 纵向滑轨高度
                        rail_h_width = $rail_h.clientWidth;

                    this.scrollWidth = scrollWidth;

                    this.clientWidth = clientWidth;

                        // 计算纵向滚动条滑块高度
                    let bar_x_width = clientWidth / scrollWidth * rail_h_width;

                    bar_x_width = bar_x_width < 20 ? 20 : bar_x_width;

                    this.rail_h_width = rail_h_width;

                    this.bar_x_width = bar_x_width;
                    
                    let call = _=>{ 
                        $bar_x.style.width = this.bar_x_width + 'px'; 

                        this.$nextTick(_=>{
                            // 重置滑块位置
                            this.setBarXLeft($panel.scrollLeft / this.ratio_x)
                        })
                    }

                    if (bar_x_width < rail_h_width) 
                        call()
                    else 
                        $rail_h.addEventListener('transitionend', call, { once: true })
                };

                this.$nextTick(_=>{
                    // 设置纵向滚动条滑块高度
                    set_bar_y_height();
                    // 设置横向滚动条滑块宽度
                    set_bar_x_width();
                })
                
               
            }
        },
        directives: {
            // 监听元素/DOM尺寸变化
            'resize': {
                bind: function (el, binding) {
                    let width = '',
                        height = '';

                    const resizeObserver = new ResizeObserver(entries => {
                        const style = window.getComputedStyle(el, null),
                            n_width = parseFloat(style.width),
                            n_height = parseFloat(style.height);

                        if (width !== n_width || height !== n_height) {

                            if (width !== '' && height !== '')
                                binding.value({
                                    width: n_width,
                                    height: n_height
                                });
                            
                            width = n_width;
                            height = n_height;
                        }
                    });

                    resizeObserver.observe(el);

                    el.__resizeObserver__ = resizeObserver
                },
                unbind: function (el) {
                    el.__resizeObserver__.unobserve(el)
                }
            }
        },
        beforeDestroy() {
            const $refs = this.$refs,
                $bar_y  = $refs.bar_y,
                $bar_x  = $refs.bar_x;
                    
            $bar_y.onmousedown  = null;
            $bar_x.onmousedown  = null;
        }
    }
</script>

<style src="./main.css" scoped></style>